export const COMPANY_SETTINGS = {
  ANALYTICS_SETTINGS: 'analytics_settings',
  COMPANY_NAME: 'company_name',
  CONFORMANCE_LANGUAGE: 'conformance_language',
  NESTING: 'nesting',
  CUI_AUDIT: 'cui_audit',
  CUSTOM_PART_ATTRS: 'custom_part_attrs',
  DATE_FORMATTING: 'date_formatting',
  UNIT_PREFERENCES: 'display_options',
  EMAIL_NOTIFICATION: 'email_notification',
  REAL_TIME_PRICING_SETTINGS: 'real-time_pricing_settings',
  SECURITY: 'security',
  SHOP_VARIABLES: 'shop_variables',
  SUPPLIER_FACILITIES: 'supplier_facilities',
};

export const ACCOUNTING = {
  BANKING_INFORMATION: 'banking_information',
  DEFAULT_TAX_RATE: 'default_tax_rate',
  DEFAULT_CHECKOUT_METHODS: 'default_checkout_methods',
  PAYMENT_INFORMATION: 'payment_information',
  CHARGE_RECEIPTS: 'charge_receipts',
};

export const DIGITAL_QUOTE_SETTINGS = {
  CHECKOUT_SETTINGS: 'checkout_settings',
  DISPLAY_SETTINGS: 'display_settings',
  EMAIL_TEMPLATES: 'email_templates',
  EXPEDITE_SETTINGS: 'expedite_settings',
  DISCOUNTS: 'discounts',
  LEAD_TIME_SETTINGS: 'lead_time_settings',
  TERMS_AND_CONDITION: 'terms_and_conditions',
  REQUOTES: 'requotes',
};

export const USER_PROFILE = {
  INFO: 'info',
  PASSWORD: 'password',
  MULTI_ORGANIZATION_SETTINGS: 'multi_organization_settings',
  TWO_FACTOR_AUTHENTICATION: 'two_factor_authentication',
  LOGIN_ACTIVITY: 'login_activity',
};

export const INTEGRATIONS = {
  API_TOKEN: 'api_token',
  QUICKBOOKS: 'quickbooks',
  QUICKBOOKS_CARD_NAME: 'Quickbooks',
};

export const QUOTE_CREATION = {
  EMAIL_FORWARDING: 'email_forwarding',
  SMART_RFQ_SETTINGS: 'smart_rfq_settings',
  DEFAULT_NOTES: 'default_notes',
  LINE_ITEM_SETTINGS: 'line_item_settings',
};
